import * as React from 'react'
import {useLocation} from 'react-router'

import SchoolsPage from '@frontrow/console/src/components/pages/schools-page/schools-page'
import {parseFilterUrl} from '@frontrow/console/src/helpers/data-table'

function SchoolsPageContainer(): React.ReactElement {
  const location = useLocation()
  const defaultFiltered = parseFilterUrl(location)

  return (
    <SchoolsPage
      defaultFiltered={defaultFiltered}
      isLoading={false}
      newSchool={null}
      error={null}
    />
  )
}

export default SchoolsPageContainer
